import { IChatContext } from 'smarthub-common'

export const chatScopes: IChatContext[] = []
